<template>
<div class="container">
  <van-nav-bar fixed title="我的咨询" left-arrow left-text="返回"  @click-left="$utils.jump('/?type=3')" right-text="我要咨询"  @click-right="$utils.jump('/ask')" />
  <div class="main__body" v-if="list!=null">
    <div class="news__list__container">
      <div class="list__item" v-for="(item,index) in list" :key="index" @click="$utils.jump(`/asksDetail/${item.id}`)">
        <MList :item="item" type="asklist"/>
      </div>
      <div class="load__wrapper" v-if="loading==true">
        <Load />
      </div>
      <div class="list__end" v-if="page==totalPage && loading==false">
        <span>已经到底啦...</span>
      </div>
      <van-empty description="暂无内容" v-if="list.length==0 && loading==false"/>
    </div>
  </div>
</div>
</template>
<script>
import MList from "@/components/MList";
import {
  mapActions
} from 'vuex'
export default {
  data() {
    return {
      page: 1,
      pageSize: 15,
      totalPage: null,
      list: null,
      loading: true
    }
  },
  components: {
    MList
  },
  computed: {},
  created() {
    this.init()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll); //监听页面滚动事件
  },
  methods: {
    handleScroll() {
      let self = this
      if (self.tabIndex == 0) {
        let bot = self.$utils.getScrollBot()
        if (bot < 150) {
          self.loadMore()
        }
      }
    },
    init() {
      if(this.list==null){
        this.getList()
      }
    },
    loadMore() {
      let {
        page,
        totalPage,
        loading
      } = this
      if (loading) {
        return false
      }
      if (totalPage != null) {
        if (page < totalPage) {
          this.page++
          this.getList();
        }
      }
    },
    async getList() {
      let self = this
      let {
        page,
        pageSize,
        list
      } = self
      self.loading = true
      let posData = {
        data: {
          page,
          pageSize
        },
        auth:true
      }
      if (list != null) {
        posData.loadMsg = false
      }
      let res = await this._getAskListM(posData)
      self.loading = false
      if (res && res.code == 200) {
        if (list == null) {
          self.list = res.data.list
        } else {
          self.list.push(...res.data.list)
        }
        self.totalPage = res.data.totalPage
      }
    },
    ...mapActions('api', ['_getAskListM'])
  }
}
</script>
<style lang="less" scoped>
.container {
    .main__body {
        margin-top: 46px;
    }
}
</style>
